// src/components/Header.js
import React from "react";
import {
  Box,
  Stack,
  Heading,
  Flex,
  useDisclosure,
  Image,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  useColorMode,
  MenuGroup,
} from "@chakra-ui/react";
import { HamburgerIcon, SettingsIcon, LockIcon } from "@chakra-ui/icons";
import { ColorModeSwitcher } from "../ColorModeSwitcher";
import eecologo from "../eecowhite.svg";
import { useDoorData } from "./context/DoorContext";
import { useNavigate } from "react-router-dom";
import Clock from "./Clock";
import { getLicenseState } from "../utils/licenseUtils";

const Header = (props) => {
  const { license } = props;

  const { colorMode } = useColorMode();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const handleToggle = () => (isOpen ? onClose() : onOpen());
  const {
    logOutUser,
    user,
    allLogs,
    allCardGroups,
    loadDataFromEmaitinimas,
    isSeveralRaspberryIps,
  } = useDoorData();
  const navigate = useNavigate();

  const { locked: licenseLocked } = getLicenseState(license || {});

  return (
    <Flex
      as="nav"
      align="center"
      justify="space-between"
      wrap="wrap"
      padding={6}
      bg="green.500"
      color="white"
      {...props}
    >
      <Flex
        align="center"
        mr={5}
        onClick={() => {
          navigate("/");
        }}
        cursor={"pointer"}
      >
        <Image width={"8rem"} mr={"1rem"} src={eecologo} />
        <Heading as="h1" size="lg" letterSpacing={"tighter"}>
          Access Control
        </Heading>
      </Flex>

      {/* Burger tik jei sistema neužrakinta */}
      {!licenseLocked && (
        <Box display={{ base: "block", md: "none" }} onClick={handleToggle}>
          <HamburgerIcon />
        </Box>
      )}

      {/* NAV mygtukai – nerodom, kai licencija pasibaigusi */}
      {!licenseLocked && (
        <Stack
          direction={{ base: "column", md: "row" }}
          display={{ base: isOpen ? "block" : "none", md: "flex" }}
          width={{ base: "full", md: "auto" }}
          alignItems="center"
          flexGrow={1}
          mt={{ base: 4, md: 0 }}
        >
          {user?.level >= 0 && (
            <Button
              onClick={() => {
                navigate("/logs");
                allLogs();
              }}
              variant="outline"
              _hover={{ bg: "green.700", borderColor: "green.700" }}
            >
              Istorija
            </Button>
          )}

          {user?.level >= 0 && isSeveralRaspberryIps && (
            <Button
              leftIcon={<LockIcon />}
              onClick={() => {
                navigate("/durys-su-ip");
              }}
              variant="outline"
              _hover={{ bg: "green.700", borderColor: "green.700" }}
            >
              Visos IP durys
            </Button>
          )}

          {user?.level === 1 && (
            <Menu justifySelf="end">
              <MenuButton
                leftIcon={<SettingsIcon />}
                variant="outline"
                as={Button}
                _hover={{ bg: "green.700", borderColor: "green.700" }}
                _active={{ bg: "green.700", borderColor: "green.700" }}
              >
                Nustatymai
              </MenuButton>
              <MenuList zIndex={2000}>
                <MenuGroup
                  textAlign={"left"}
                  color={colorMode === "light" ? "#333" : "#fff"}
                  title="Naudotojų nustatymai"
                >
                  <MenuItem
                    fontSize={"1rem"}
                    color={colorMode === "light" ? "#333" : "#fff"}
                    _hover={{ bg: "green.600", color: "#fff" }}
                    onClick={() => {
                      navigate("/admin");
                    }}
                  >
                    Naudotojų valdymas
                  </MenuItem>
                </MenuGroup>
                {!loadDataFromEmaitinimas && (
                  <MenuGroup
                    textAlign={"left"}
                    color={colorMode === "light" ? "#333" : "#fff"}
                    title="Praėjimo nustatymai"
                  >
                    <MenuItem
                      fontSize={"1rem"}
                      color={colorMode === "light" ? "#333" : "#fff"}
                      _hover={{ bg: "green.600", color: "#fff" }}
                      onClick={() => {
                        navigate("/cards");
                      }}
                    >
                      Kortelių valdymas
                    </MenuItem>
                    <MenuItem
                      fontSize={"1rem"}
                      color={colorMode === "light" ? "#333" : "#fff"}
                      _hover={{ bg: "green.600", color: "#fff" }}
                      onClick={() => {
                        navigate("/cardgroups");
                      }}
                    >
                      Kortelių grupės
                    </MenuItem>
                    <MenuItem
                      fontSize={"1rem"}
                      color={colorMode === "light" ? "#333" : "#fff"}
                      _hover={{ bg: "green.600", color: "#fff" }}
                      onClick={() => {
                        navigate("/dooradmin");
                      }}
                    >
                      Durų administravimas
                    </MenuItem>
                    {allCardGroups.length !== 0 && (
                      <MenuItem
                        fontSize={"1rem"}
                        color={colorMode === "light" ? "#333" : "#fff"}
                        _hover={{ bg: "green.600", color: "#fff" }}
                        onClick={() => {
                          navigate("/doortime");
                        }}
                      >
                        Durų laikų valdymas
                      </MenuItem>
                    )}
                  </MenuGroup>
                )}
              </MenuList>
            </Menu>
          )}
        </Stack>
      )}

      {/* Logout paliekam visada */}
      <Box
        display={{ base: isOpen ? "block" : "none", md: "block" }}
        mt={{ base: 4, md: 0 }}
      >
        <Heading mb={"0.6rem"}>
          <Clock />
        </Heading>
        {user && (
          <Button
            colorScheme={"red"}
            onClick={() => {
              logOutUser();
            }}
          >
            Atsijungti
          </Button>
        )}
        <ColorModeSwitcher justifySelf="flex-end" />
      </Box>
    </Flex>
  );
};

export default Header;
